import { render, staticRenderFns } from "./UpdateWhatsApp.vue?vue&type=template&id=412fadb4&"
import script from "./UpdateWhatsApp.vue?vue&type=script&lang=js&"
export * from "./UpdateWhatsApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports